require('./header.less');

interface IUser{
    fullname: string,
    username: string,
    email: string,
    phonenumber: string
    resetPasswordRequired: boolean
    languageCode: string
}

interface IHeaderController{
    user: IUser;
}

class HeaderController implements IHeaderController {
    public user:IUser;
    constructor(private $state, private userService, private $mdMedia, private $mdUtil, private $mdSidenav,private $rootScope, private hasAccessTo, private $location) {
        $rootScope.sidenavOpen = true;
        this.user = this.userService.userDetails;
    }


    logout() {
        this.userService.logout().then(() => this.$state.go('login'));
    }
    goHome() {
        var hasOrderAccess = this.hasAccessTo.orders();
        var hasPrognosisAccess = this.hasAccessTo.prognosis();
        if(hasOrderAccess){
            this.$location.url('/orders?pageSize=100&pageNo=0&sort=vip|desc,orderNo|asc');
        }
        else if(hasPrognosisAccess){
            this.$location.url('/prognosis');
        }
        else{
            this.$location.url('/');
        }
    }

    toggleLeft() {
        if (this.$mdMedia('gt-md')) {
            this.$rootScope.sidenavOpen = !this.$rootScope.sidenavOpen;
        } else {
            this.$mdSidenav("left").toggle();
        }
    }
}

class HeaderOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcHeaderController";
    public template: any = require('./header.html');
}

rkcApp.controller("rkcHeaderController", ['$state','userService','$mdUtil','$mdMedia','$mdSidenav','$rootScope','$scope','hasAccessTo','$location', function($state,userService, $mdUtil,$mdMedia, $mdSidenav, $rootScope, $scope, hasAccessTo, $location){
    $scope.$watch(function(){
        return $state.$current.name;
    }, function(newVal, oldVal){
        if(newVal === 'loggedin.prognosis'){
            $rootScope.sidenavOpen = false;
        }
    });
    return new HeaderController($state,userService, $mdMedia, $mdUtil, $mdSidenav, $rootScope, hasAccessTo,$location);
}])
    .component("rkcHeader", new HeaderOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/header/header.ts
 **/